/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyDataPoint {
    getFixupPrototypeFunction() { return CostAnomalyDataPoint.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyDataPoint>): CostAnomalyDataPoint {
        let obj = Object.assign(new CostAnomalyDataPoint(), model);
        CostAnomalyDataPoint.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyDataPoint>): CostAnomalyDataPoint {
        if (!model) return null;
        return CostAnomalyDataPoint.newInstance(<CostAnomalyDataPoint> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyDataPoint) {
        if (!obj) return;

        models.CostAnomalyDataPoint.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyDataPoint): boolean {
        Object.setPrototypeOf(obj, CostAnomalyDataPoint.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.value === undefined) {
            this.value = 0;
        }
        if (typeof this.timestamp === "string") {
            this.timestamp = new Date(<string><any>this.timestamp);
        }
    }

    /**
     * Bill date in yyyy-mm-dd format
     */
    timestamp: Date;

    /**
     * Billed cost for the bill date.
     */
    value: number;

}
